import {Share, Cms} from '@/api'
import mdUtils from '../utils/mdUtils';
class ShareService {
  constructor() {
    this.jsTicketKey = 'wxJsTicketKey'

    this.shareType = {
      // 主页
      home: -1,
      personalIndex:-2
    }
  }

  init(res) {
    try {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: process.env.VUE_APP_WX_APP_ID, // 必填，公众号的唯一标识
        timestamp: res.TimeStamp, // 必填，生成签名的时间戳
        nonceStr: res.NonceStr, // 必填，生成签名的随机串
        signature: res.Signature,// 必填，签名
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
        ] // 必填，需要使用的JS接口列表
      });
    } catch (error) {
      console.log(error)
    }
  }
  getBack(vm, opts, callBack) {
    if (!mdUtils.isWeiXin()) {
      return
    }
    let url = window.location.href
    // let resb = {
    //   "Url": "string",
    //   "TimeStamp": "string",
    //   "NonceStr": "string",
    //   "JsTicket": "string",
    //   "Signature": "string",
    //   "JsTicketExpireIn": 0
    // }
    // let JsTicket = this.getJsTicket()
    vm.$api(Share.BuildWxShare, {
      "AppId": process.env.VUE_APP_WX_APP_ID,
      // "JsTicket": JsTicket,
      "Url": url,
    }, false,false).then((res) => {
      // this.setJsTicket(res)
      this.init(res)
      return res
    })
    .then((res) => {
      wx.error((res) => {
        console.log(res)
      })
      wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
        typeof callBack === 'function' && callBack(res)
        this.handleOnShare(opts, vm)
      })
    })
    .catch((err)=> {
      console.log(err)
      // vm.$tips.toast('失败：' + JSON.stringify(err))
    })
  }

  handleOnShare(opts, vm) {
    let that = this
    // menu 里 的分享默认添加
    // wx.updateAppMessageShareData({ 
    //   title: opts.title, // 分享标题
    //   desc: opts.desc, // 分享描述
    //   link: opts.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: opts.img_url, // 分享图标
    //   success: function () {
    //     // 设置成功
    //     that.handleShareSuccess(opts.ArticleId, vm)
    //   }
    // })

    // wx.updateTimelineShareData({ 
    //   title: opts.title, // 分享标题
    //   link: opts.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //   imgUrl: opts.img_url, // 分享图标
    //   success: function () {
    //     // 设置成功
    //     that.handleShareSuccess(opts.ArticleId, vm)
    //   }
    // })

    wx.onMenuShareAppMessage({ 
      title: opts.title, // 分享标题
      desc: opts.desc, // 分享描述
      link: opts.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: opts.img_url, // 分享图标
      success: function () {
        // 设置成功
        that.handleShareSuccess(opts.ArticleId, vm)
      }
    })

    wx.onMenuShareTimeline({ 
      title: opts.title, // 分享标题
      link: opts.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: opts.img_url, // 分享图标
      success: function () {
        // 设置成功
        that.handleShareSuccess(opts.ArticleId, vm)
      }
    })
  }

  handleShareSuccess(ArticleId, vm) {
    vm.$api(Cms.ForwardRecordInsert, {ArticleId: ArticleId}, false, false).then(() => {
    })
  }

  setJsTicket(opts) {
    if (opts.JsTicketExpireIn) {
      let exdays = Number(opts.JsTicketExpireIn) / 60 /60/ 24
      this.setCookie(this.jsTicketKey, opts.JsTicket,  exdays)
    }
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  } 

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
         }
         if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
         }
     }
    return "";
  } 

  getJsTicket() {
    return this.getCookie(this.jsTicketKey)
  }
}

export default new ShareService()